import useAnalytics from "hooks/useAnalytics";
import TableSimple from "ds/components/TableSimple";

import useSharedModulesTableStore from "./useSharedModulesTableStore";
import { SHARED_MODULES_TABLE_CELLS } from "./Cells";
import { FILTERS_ORDER_SETTINGS_KEY, SORT_CONFIG } from "./constants";
import { SharedModuleData } from "../../gql";

type SharedModulesTableProps = {
  sharedModules: SharedModuleData[];
  loadingContent?: boolean;
};

const SharedModulesTable = ({ sharedModules, loadingContent }: SharedModulesTableProps) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimple
      data={sharedModules}
      loading={loadingContent}
      store={useSharedModulesTableStore}
      ariaLabel="Shared modules table"
      rowsPerPage={10}
      trackAnalytics={trackAnalytics}
      cellPerColumn={SHARED_MODULES_TABLE_CELLS}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      sortConfig={SORT_CONFIG}
    />
  );
};

export default SharedModulesTable;
